import { Box, Typography } from '@mui/joy';
import { CustomStatusPanelProps } from 'ag-grid-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { NumberHelper } from 'core/helpers';

export const ServerSideTotalRowCount = ({ api, context }: CustomStatusPanelProps) => {
  const [totalRowCount, setTotalRowCount] = useState<number>(0);
  const entityType = context.entityType;

  const { t } = useTranslation();

  useEffect(() => {
    const updateStatusBar = () => {
      const firstRow = api.getDisplayedRowAtIndex(0);
      const firstRowIsLoading = firstRow && !firstRow.data;

      if (firstRowIsLoading) {
        return;
      }

      setTotalRowCount(api.getDisplayedRowCount());
    };

    api.addEventListener('modelUpdated', updateStatusBar);

    return () => {
      !api.isDestroyed() && api.removeEventListener('modelUpdated', updateStatusBar);
    };
  }, [api]);

  const formatEntityType = entityType.replace(/([^aeiou])y$/, '$1ie');

  return (
    <Box gap="4px" className="ag-status-name-value ag-status-panel">
      <Typography className="ag-status-name">
        {t('labelTotal')} {t(`label${formatEntityType}s`)}:
      </Typography>
      <Typography className="ag-status-value" sx={{ fontWeight: 700 }}>
        {NumberHelper.formatInteger({ amount: totalRowCount })}
      </Typography>
    </Box>
  );
};
